import { ReactNode } from "react"

export interface CwColumn<T> {
  key: string
  label: string
  render?: (row: T) => ReactNode
}

export default function CwDataTable<T extends { id?: number | string }>({
  columns,
  rows,
  onRowClick,
  empty,
}: {
  columns: CwColumn<T>[]
  rows: T[]
  onRowClick?: (row: T) => void
  empty?: ReactNode
}) {
  if (rows.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-lg px-6 py-16 text-center font-source text-gray-600">
        {empty}
      </div>
    )
  }

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
      <table className="w-full text-start font-source">
        <thead>
          <tr className="bg-secondary-extra-light text-primary-dark">
            {columns.map((column) => (
              <th key={column.key} className="px-5 py-3 text-start font-semibold">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr
              key={String(row.id ?? index)}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              className={`border-t border-gray-100 ${onRowClick ? "cursor-pointer hover:bg-secondary-extra-light" : ""} ${index % 2 === 1 ? "bg-secondary-extra-light/60" : ""}`}
            >
              {columns.map((column) => (
                <td key={column.key} className="px-5 py-3">
                  {column.render
                    ? column.render(row)
                    : String((row as Record<string, unknown>)[column.key] ?? "")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
